<template>
  <div id="app">
    <vue-confirm-dialog></vue-confirm-dialog>
    <component :is="layout">
      <router-view/>
    </component>

  </div>
</template>

<script>
// import EmptyLayout from '@/layouts/EmptyLayout';
// import MainLayout from '@/layouts/MainLayout';
export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || 'empty') + '-layout';
    }
  },

  // components: {
  //   EmptyLayout,
  //   MainLayout
  // }
}
</script>

<style lang="scss">
@import './assets/styles/styles.scss';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}


</style>
